'use client';

import { type ReactElement } from 'react';

import LoadingIndicator from '../../loading-indicator';
import PdpTemplate from '../shared';
import { experienceSections } from './sections';

import type { ProductDetailData } from './types';
import { PdpBreadcrumb, ProductDetailProperty, ProductDetailStores } from '../shared/types';

export type Props = {
	product: ProductDetailData;
	className?: string;
	property: ProductDetailProperty;
	breadcrumb?: PdpBreadcrumb;
} & ProductDetailStores;

export default function ProductDetailPage({
	product,
	className = '',
	userStore,
	globalStore,
	productAvailabilityStore,
	bookingsStore,
	cartStore,
	property,
	breadcrumb,
}: Props): ReactElement | null {
	return (
		<PdpTemplate
			product={product}
			sections={experienceSections(
				product,
				{
					userStore,
					globalStore,
					productAvailabilityStore,
					bookingsStore,
					cartStore,
				},
				breadcrumb?.items
			)}
			className={className}
			stores={{
				userStore,
				bookingsStore,
				globalStore,
				cartStore,
				productAvailabilityStore,
			}}
			property={property}
		/>
	);
}
